import React from "react";
import PropTypes from "prop-types";
// import css from 'cape-style'
import marked from "marked";

import { ImgCap, Description } from "./styles";

function ImageCaption({
  description,
  medium,
  size,
  title,
  year,
  showMetadata,
}) {
  return (
    <div>
      {showMetadata && showMetadata == "true" && (
        <ImgCap>
          {title && (
            <li className="title">
              <h3>
                <strong>{title}</strong>
                {year && <span>, {year}</span>}
              </h3>
            </li>
          )}
          {medium && <li className="medium">{medium}</li>}{" "}
          {size && (
            <li className="size">
              <span className="size">{size}</span>
            </li>
          )}
          {description && (
            <li className="description">
              <Description>
                <p>{description}</p>
              </Description>
            </li>
          )}
        </ImgCap>
      )}
    </div>
  );
}

ImageCaption.propTypes = {
  description: PropTypes.string.isRequired,
  medium: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  year: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};
ImageCaption.defaultProps = {};

export default ImageCaption;



// WEBPACK FOOTER //
// ./src/components/StudentDetail/ImageCaption.jsx